class Header {
  constructor() {
    this.updateHeaderStyle();
    this.getHeaderHeight();
    this.stickyHeader();
  }

  updateHeaderStyle() {
    if (!document.body.classList.contains("transparent")) {
      return;
    }

    let scrollPositionY = window.scrollY;
    const body = document.querySelector("body");
    const headerHeight = 100;

    window.addEventListener("scroll", () => {
      scrollPositionY = window.scrollY;

      if (scrollPositionY >= headerHeight) {
        body.classList.remove("transparent");
      } else {
        body.classList.add("transparent");
      }
    });
  }

  getHeaderHeight() {
    const header = document.getElementById("HeaderWrapper");
    const toolbar = document.getElementById("shopify-section-toolbar");
    const headerHeight = header.offsetHeight;

    // Add 10 for border width
    const toolbarHeight = toolbar.offsetHeight + 10;
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
    document.body.style.setProperty(
      "--header-toolbar-height",
      `${toolbarHeight}px`
    );
    return headerHeight;
  }

  stickyHeader() {
    const header = document.querySelector('#SiteHeader[data-sticky="true"]');
    //console.log(header);
    const headerHeight = header.clientHeight;
    let scrollPos = 0;
    let scrollDirection;
    let scrollPositionY;

    if (!header) {
      return;
    }

    document.addEventListener("scroll", (evt) => {
      scrollPositionY = window.scrollY;
      const scrollingDirection = getScrollDirection();
      if (scrollPositionY > headerHeight) {
        // console.log('sticky');
        header.classList.add("sticky");
        if (scrollingDirection === "up") {
          header.classList.remove("sticky");
        }
      } else {
        // console.log('not sticky');
        header.classList.remove("sticky");
      }

      // console.log(evt);
    });

    function getScrollDirection() {
      // console.log('scrolling');
      // console.log({scrollPositionY, scrollPos});
      // adding scroll event
      // detects new state and compares it with the new one
      if (document.body.getBoundingClientRect().top > scrollPos) {
        scrollDirection = "up";
      } else {
        scrollDirection = "down";
        // saves the new position for iteration.
        scrollPos = document.body.getBoundingClientRect().top;
      }
      // console.log({scrollPos, scrollDirection});

      return scrollDirection;
    }
  }
}

export default Header;
